import { render, staticRenderFns } from "./ModalHeaderWithPrevious.vue?vue&type=template&id=4e87ca71&scoped=true"
import script from "./ModalHeaderWithPrevious.vue?vue&type=script&lang=js"
export * from "./ModalHeaderWithPrevious.vue?vue&type=script&lang=js"
import style0 from "./ModalHeaderWithPrevious.vue?vue&type=style&index=0&id=4e87ca71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e87ca71",
  null
  
)

export default component.exports